"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MountLinkPreviewAccountDefaults = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var link_settings_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/link-settings-75.svg"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LinkPreview_1 = require("@CommonFrontendBackend/Project/LinkPreview");
var LinkPreviewCard_1 = require("../../Common/LinkPreview/LinkPreviewCard");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var CustomLinkPreviewAccountSettingsStore_1 = require("DataStores/Account/CustomLinkPreviewAccountSettingsStore");
var BASE_CLASS_NAME = "link-preview-account-defaults";
var MountLinkPreviewAccountDefaults = function (mountReactComponent) { return function (props) {
    return mountReactComponent(react_1.default.createElement(LinkPreviewAccountDefaults, __assign({}, props)));
}; };
exports.MountLinkPreviewAccountDefaults = MountLinkPreviewAccountDefaults;
var LinkPreviewAccountDefaults = (function (_super) {
    __extends(LinkPreviewAccountDefaults, _super);
    function LinkPreviewAccountDefaults() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultDescription = "";
        _this.defaultImageUrl = "";
        _this.onDescriptionChange = function (value) {
            _this.defaultDescription = value;
        };
        _this.getDefaultAccountLinkPreviewDescription = function () {
            var accountName = _this.props.accountStore.name;
            var hasCustomDomain = _this.props.usingFeature(FeatureFlag_1.FeatureFlag.Domain);
            if (hasCustomDomain) {
                return "A web document prepared by the ".concat(accountName, " team");
            }
            else if (!accountName) {
                return "Made with Qwilr.";
            }
            else {
                return "Made with Qwilr by the ".concat(accountName, " team");
            }
        };
        _this.fireTelemetry = function (updatingTo) { return __awaiter(_this, void 0, void 0, function () {
            var updatingToImageType;
            return __generator(this, function (_a) {
                updatingToImageType = updatingTo ? "custom" : "default";
                this.props.telemetry.track("Link Preview Account Image Changed", {
                    link_preview_from: this.updatingFromImageType,
                    link_preview_to: updatingToImageType,
                });
                this.updatingFromImageType = updatingToImageType;
                return [2];
            });
        }); };
        _this.saveAccountLinkPreviewDefaults = function () {
            var newImageUrl = _this.defaultImageUrl === LinkPreview_1.LINK_PREVIEW_DEFAULT_URL ? "" : _this.defaultImageUrl;
            var newDescription = _this.defaultDescription === _this.getDefaultAccountLinkPreviewDescription() ? "" : _this.defaultDescription;
            _this.fireTelemetry(newImageUrl);
            _this.customLinkPreviewStore.setValues(newImageUrl, newDescription);
        };
        _this.updateAccountLinkPreviewDefaults = function () {
            return new Promise(function (resolve) {
                setTimeout(function () {
                    _this.saveAccountLinkPreviewDefaults();
                }, 1000);
                resolve();
            });
        };
        _this.restoreAccountLinkPreviewDefaults = function () {
            return new Promise(function (resolve) {
                setTimeout(function () {
                    _this.defaultDescription = _this.getDefaultAccountLinkPreviewDescription();
                    _this.defaultImageUrl = LinkPreview_1.LINK_PREVIEW_DEFAULT_URL;
                    _this.saveAccountLinkPreviewDefaults();
                }, 1000);
                resolve();
            });
        };
        _this.openLibraryClick = function () {
            var assetLibraryOverlay = _this.props.assetLibraryOverlay;
            assetLibraryOverlay.launchBasicOverlay(function (mediaSource, data) {
                (0, mobx_1.runInAction)(function () {
                    _this.defaultImageUrl = data.url;
                });
            });
        };
        return _this;
    }
    LinkPreviewAccountDefaults.prototype.componentDidMount = function () {
        this.defaultDescription = this.customLinkPreviewStore.description || this.getDefaultAccountLinkPreviewDescription();
        this.defaultImageUrl = this.customLinkPreviewStore.imageUrl || LinkPreview_1.LINK_PREVIEW_DEFAULT_URL;
        this.updatingFromImageType = this.defaultImageUrl === LinkPreview_1.LINK_PREVIEW_DEFAULT_URL ? "default" : "custom";
    };
    Object.defineProperty(LinkPreviewAccountDefaults.prototype, "customLinkPreviewStore", {
        get: function () {
            return this.props.accountStore.getCustomLinkPreviewStore();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LinkPreviewAccountDefaults.prototype, "updateButtonDisable", {
        get: function () {
            return !this.hasDescriptionChanged && !this.hasImageChanged;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LinkPreviewAccountDefaults.prototype, "restoreButtonDisable", {
        get: function () {
            return (this.defaultDescription === this.getDefaultAccountLinkPreviewDescription() &&
                this.defaultImageUrl === LinkPreview_1.LINK_PREVIEW_DEFAULT_URL);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LinkPreviewAccountDefaults.prototype, "hasDescriptionChanged", {
        get: function () {
            var valueOnAccount = this.customLinkPreviewStore.description;
            if (this.defaultDescription !== valueOnAccount) {
                if (!valueOnAccount) {
                    return this.defaultDescription !== this.getDefaultAccountLinkPreviewDescription();
                }
                else {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LinkPreviewAccountDefaults.prototype, "hasImageChanged", {
        get: function () {
            var valueOnAccount = this.customLinkPreviewStore.imageUrl;
            if (this.defaultImageUrl !== valueOnAccount) {
                if (!valueOnAccount) {
                    return this.defaultImageUrl !== LinkPreview_1.LINK_PREVIEW_DEFAULT_URL;
                }
                else {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    LinkPreviewAccountDefaults.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("section", { className: "settings-page" },
            react_1.default.createElement("div", { className: "setting-section ".concat(BASE_CLASS_NAME) },
                react_1.default.createElement("header", { className: "setting-section-header" },
                    react_1.default.createElement("div", { className: "icon" },
                        react_1.default.createElement(kaleidoscope_1.SVG, { className: "extra-large", src: link_settings_75_svg_1.default })),
                    react_1.default.createElement("h2", null, "Link Preview Defaults"),
                    react_1.default.createElement("p", { className: "explainer" }, "Change the default description and preview image for all Qwilr pages created on this account.")),
                react_1.default.createElement("section", { className: "".concat(BASE_CLASS_NAME, "__content") },
                    react_1.default.createElement("section", { className: "".concat(BASE_CLASS_NAME, "__content--image space-stack-l") },
                        react_1.default.createElement(LinkPreviewCard_1.LinkPreviewCard, { clickable: true, imageUrl: this.defaultImageUrl, handleOnClick: this.openLibraryClick })),
                    react_1.default.createElement(kaleidoscope_2.TextInput, { type: kaleidoscope_2.TextInputType.Text, size: kaleidoscope_2.TextInputSize.Large, error: !this.defaultDescription ? "Default page description cannot be empty" : "", label: "Default Page Description", value: this.defaultDescription, onChange: this.onDescriptionChange }),
                    react_1.default.createElement("section", { className: "".concat(BASE_CLASS_NAME, "__content--buttons-container") },
                        react_1.default.createElement(kaleidoscope_2.Button, { disabled: this.restoreButtonDisable, type: kaleidoscope_2.ButtonType.Secondary, size: kaleidoscope_2.ButtonSize.Small, successMessage: "Saved", onClick: function () { return _this.restoreAccountLinkPreviewDefaults(); } }, "Restore defaults"),
                        react_1.default.createElement(kaleidoscope_2.Button, { disabled: this.updateButtonDisable || !this.defaultDescription, size: kaleidoscope_2.ButtonSize.Small, successMessage: "Saved", onClick: function () { return _this.updateAccountLinkPreviewDefaults(); } }, "Update preview defaults"))))));
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], LinkPreviewAccountDefaults.prototype, "defaultDescription", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], LinkPreviewAccountDefaults.prototype, "defaultImageUrl", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], LinkPreviewAccountDefaults.prototype, "updatingFromImageType", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkPreviewAccountDefaults.prototype, "onDescriptionChange", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof CustomLinkPreviewAccountSettingsStore_1.CustomLinkPreviewAccountSettingsStore !== "undefined" && CustomLinkPreviewAccountSettingsStore_1.CustomLinkPreviewAccountSettingsStore) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], LinkPreviewAccountDefaults.prototype, "customLinkPreviewStore", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], LinkPreviewAccountDefaults.prototype, "updateButtonDisable", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], LinkPreviewAccountDefaults.prototype, "restoreButtonDisable", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], LinkPreviewAccountDefaults.prototype, "hasDescriptionChanged", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], LinkPreviewAccountDefaults.prototype, "hasImageChanged", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkPreviewAccountDefaults.prototype, "saveAccountLinkPreviewDefaults", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkPreviewAccountDefaults.prototype, "updateAccountLinkPreviewDefaults", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkPreviewAccountDefaults.prototype, "restoreAccountLinkPreviewDefaults", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkPreviewAccountDefaults.prototype, "openLibraryClick", void 0);
    LinkPreviewAccountDefaults = __decorate([
        mobx_react_1.observer
    ], LinkPreviewAccountDefaults);
    return LinkPreviewAccountDefaults;
}(react_1.default.Component));
exports.default = LinkPreviewAccountDefaults;
